export default __webpack_public_path__ + "static/media/Search.52ac158c.svg";